import tools from 'utils/tools';

const DashboardLayout = tools.lazyWithRetry(() =>
  import('layouts/DashboardLayout'),
);
const TermsAndConditions = tools.lazyWithRetry(() =>
  import('components/pages/SinglePages/TermsAndConditions'),
);

const publicSinglePageRoutes = [
  {
    path: '/',
    element: <DashboardLayout isPublicPage />,

    children: [
      { path: 'terms-and-conditions', element: <TermsAndConditions /> },
    ],
  },
];

export default publicSinglePageRoutes;
